var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StaticInfo',{attrs:{"name":_vm.$t('orderDetail.status'),"value":_vm.translatedStatus,"valueClass":[("status__" + _vm.status), _vm.isInvoiced ? 'invoiced' : ''],"data-testid":"order-form__status-info"}})}
var staticRenderFns = []

export { render, staticRenderFns }